<template>
  <div class="proBox">
  	     	  <p class="tit">数据持有权证</p>
  	     	  <hr class="title-underline">
  	     	  <p class="proid"><span>编号：</span> <span>{{  Date.parse(new Date(txInfo.time).toString()) }}</span></p>
  	     	  <p class="proid"><span>存证哈希值：</span> <span>{{txInfo.tx_hash}}</span></p>
  	     	  <p class="proid"><span>资产名称：</span> <span>{{txInfo.memo.modelName}}</span></p>
  	     	  <p class="proid"><span>资产编号：</span> <span>{{txInfo.memo.modelHash}}</span></p>
  	     	  <!-- <p class="proid"><span>资产作者：</span> <span>曹子健</span></p> -->
  	     	  <p class="proid"><span>资产类型：</span> <span>{{txInfo.memo.indexID}}</span></p>
  	     	  <p class="proid"><span>存证地址：</span> <span>{{txInfo.to}}</span></p>
  	     	  <p class="proid"><span>存证时间：</span> <span>{{txInfo.time}}</span></p>
  	     	  <div class="con-unit">
  	     		<p>湖北省数权数据有限公司</p>
  	     		<p class="time">{{txInfo.time}}</p>
  	     	  </div>
</div>
</template>

<script>
export default {
  props: ['txInfo', 'certificateType']
};
</script>
<style lang="scss" scoped>
	.container {
	  display: flex;
	  min-height: 100vh;
	}
	
	.sidebar {
	 
	  height: 100vh; /* 侧边栏高度 */
	  
	}
	
	.content {
	 
	  width:800px;
	  padding: 20px; /* 内容区域的内边距 */
	  background-color: rgb(37,49,63);
	}
.text {
  .van-cell__value {
    color: blue;
  }
}
.block_txs {
  margin-top: 20px;
}
.mobile_cell {
  border: 1px solid #ebedf0;
  border-width: 1px 0;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
}
.van-cell__value {
  flex: 3;
}
.van-cell__value {
  text-align: left;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  // overflow: hidden;
}
.noBox {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  margin: 10px 12px;
}
.van-cell {
  padding: 10px 16px 10px 16px;
  background-color: black;
}

.tx_address,
.tx {
  margin: 0 12px;
  background-color: #fff;
}

.tx_address {
  margin-top: 30px !important;
  margin: 0 12px;
  background-color: #fff;
}
.pagination {
  margin: 0 12px;
}
.van-cell-group__title {
  padding: 8px 0 8px;
  font-size: 16px;
}
.van-cell__title {
  flex: 2;
}
::v-deep .el-dialog__body {
  padding: 0px;
}
::v-deep .el-dialog {
	height:1080px;
  width: 750px;
  margin-top: 60px !important;
}
#pdfDom {
  /* 要想pdf周边留白，要在这里设置 */
  width: 750px;
}
.proBox {
  background: url("../assets/OIP-C.jpg") no-repeat;
  background-size: cover;
  width: 750px;
  height:1080px;
  padding: 90px 94px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
 
  font-family: SimSun;
}
.tit {
  color: rgb(42,111,176);
  font-size: 28px;
  font-weight: 700;
  position: relative;
  text-align: center;
  top: -6px;
  left: 8px;
  letter-spacing: 20px;
  font-family: STHeiti;
  margin-top:110px;
  margin-bottom:-5px;
}
.proid {
  font-weight: 500;
  padding:25px;
   color: rgb(42,111,176);
  /* margin-right: 5px; */
}
.con {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  margin: 10px 0;
  line-height: 32px;
  text-indent: 2em;
}
.con-name {
  font-family: 华文行楷, STXingkai;
  border-bottom: 2px solid #000;
}
.con-unit {
  font-size: 18px;
  font-weight: 700;
  position: absolute;
  right: 100px;
  bottom: 100px;
  text-align: center;
  letter-spacing: 3px;
}
.con-unit p {
  margin: 5px 0;
}
.con-footer {
  font-size: 18px;
  font-weight: 700;
  position: absolute;
  bottom: 45px;
  left: 0;
  right: 0;
  text-align: center;
}
.chapter {
  border-radius: 50%;
  position: absolute;
  bottom: 75px;
  right: 134px;
}
.van-cell {
		background-color: rgb(26,35,45);
		color:white;
		
	}
	.tx-form {
	  font-family: Arial, sans-serif;
	  margin: 20px;
	  padding: 20px;
	  border: 1px solid #ccc;
	  border-radius: 5px;
	  background-color: #f9f9f9;
	  width:700px;
	}
	
	.form-group {
	  margin-bottom: 15px;
	}
	
	.form-group label {
	  display: block;
	  font-weight: bold;
	  margin-bottom: 5px;
	}
	
	.form-group span {
	  display: block;
	  padding: 5px;
	  border: 1px solid #ddd;
	  border-radius: 3px;
	  background-color: #fff;
	}
	
	/* 可以添加一些响应式设计 */
	@media (max-width: 600px) {
	  .form-group label,
	  .form-group span {
	    display: block;
	    width: 100%;
	  }
	}
	.action-form {
	  font-family: Arial, sans-serif;
	  margin: 20px;
	  padding: 20px;
	  border: 1px solid #ccc;
	  border-radius: 5px;
	  background-color: #f9f9f9;
	  width:700px;
	}
	
	.action-group {
	  margin-bottom: 15px;
	}
	
	.form-group {
	  margin-bottom: 10px;
	}
	
	.form-group label {
	  display: block;
	  font-weight: bold;
	  margin-bottom: 5px;
	}
	
	.form-group span {
	  display: block;
	  padding: 5px;
	  border: 1px solid #ddd;
	  border-radius: 3px;
	  background-color: #fff;
	  cursor: pointer; /* 当span可点击时 */
	  user-select: none; /* 防止用户选择文本 */
	}
	
	/* 为可点击的span添加样式 */
	.form-group span[clickable] {
	  color: blue;
	  text-decoration: underline;
	}
	
	/* 响应式设计 */
	@media (max-width: 600px) {
	  .form-group label,
	  .form-group span {
	    display: block;
	    width: 100%;
	  }
	}
	.page-header {
	  padding: 15px; /* 根据需要调整内边距 */
	  background-color: rgb(37,49,63); /* 背景颜色 */
	  position: relative; /* 相对定位，如果需要定位子元素 */
	  font-size:23px;
	  color:white;
	  font-weight:bold;
	
	   
	} 

	
	/* 标题美化 */
	.tit {
	  font-size: 42px; /* 更大的字体 */
	  font-weight: bold;
	  color: rgb(38,113,164); /* 更深的文字颜色 */
	  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); /* 文字阴影 */
	}
	
	/* 信息项美化 */
	.proid {
	  font-size: 20px; /* 更大的字体 */
	 font-weight: bold;
	  border-bottom: 1px solid #eee; /* 下边框 */
	  padding-bottom: 5px; /* 下边距 */
	  margin-bottom: 10px; /* 下边距 */
	}
	
	/* 按钮美化 */
	.el-button {
	  border-radius: 20px; /* 圆角按钮 */
	  padding: 10px 20px; /* 按钮内边距 */
	  font-size: 16px; /* 字体大小 */
	  transition: background-color 0.3s; /* 背景色变化动画 */
	}
	
	.el-button:hover {
	  background-color: #409eff; /* 鼠标悬浮时的背景色 */
	  color: white; /* 文字颜色 */
	}
	
	/* 下载选项美化 */
	.el-switch {
	  margin-bottom: 10px; /* 下边距 */
	}
	
	/* 盖章效果美化 */
	.chapter canvas {
	  border-radius: 50%; /* 圆形盖章 */
	  border: 2px solid #cf0c0c; /* 盖章边框 */
	}
	.title-underline {
	  border: none; /* 移除默认边框 */
	  height: 2px; /* 设置横线厚度 */
	  background-color: rgb(38,113,164); /* 设置横线颜色 */
	  width: 450px; /* 设置横线宽度 */
	  margin-bottom:20px;
	}
</style>
